import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const useGTM = () => {
  const pushEvent = (event: string, data?: Record<string, any>) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event,
        ...data,
      });
    }
  };

  return { pushEvent };
};

// Page view tracking hook
export const usePageTracking = () => {
  const { pushEvent } = useGTM();

  useEffect(() => {
    pushEvent('pageview', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, []);
};
